"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-extraneous-dependencies */
// @ts-ignore
const reach_router_1 = require("@gatsbyjs/reach-router");
const react_1 = __importDefault(require("react"));
// @ts-ignore
const helmet_1 = __importDefault(require("../gatsby/sourcing/helmet"));
const GlobalSeo = ({ globalData: data, pageContext }) => {
    const { pathname } = (0, reach_router_1.useLocation)();
    const { titleSuffix, twitterAccount } = data.datoCmsSite?.globalSeo || {};
    const { title, description, image, twitterCard } = data.datoCmsSite?.globalSeo?.fallbackSeo || {};
    return (react_1.default.createElement(helmet_1.default, { htmlAttributes: { lang: pageContext?.datoLocale || 'en' }, favicon: data.datoCmsSite?.faviconMetaTags },
        react_1.default.createElement("title", null,
            title,
            titleSuffix),
        description && react_1.default.createElement("meta", { name: "description", content: description }),
        title && react_1.default.createElement("meta", { property: "og:title", content: title }),
        description && react_1.default.createElement("meta", { property: "og:description", content: description }),
        image?.url && react_1.default.createElement("meta", { property: "og:image", content: image?.url }),
        react_1.default.createElement("meta", { property: "og:locale", content: (pageContext?.datoLocale || 'en').replace('-', '_') }),
        react_1.default.createElement("meta", { property: "og:type", content: "website" }),
        react_1.default.createElement("meta", { property: "og:url", content: `${process.env.GATSBY_REAL_BASE_URL}${pathname}` }),
        twitterCard && react_1.default.createElement("meta", { name: "twitter:card", content: twitterCard }),
        twitterAccount && react_1.default.createElement("meta", { name: "twitter:creator", content: twitterAccount }),
        title && react_1.default.createElement("meta", { name: "twitter:title", content: title }),
        description && react_1.default.createElement("meta", { name: "twitter:description", content: description }),
        image?.url && react_1.default.createElement("meta", { name: "twitter:image", content: image?.url })));
};
exports.default = GlobalSeo;
//# sourceMappingURL=global-seo.js.map